// Any z-index values used in the application should belong here:
const background = -1
const base = 0
const foreground = base + 1000

export default {
  background,
  base,
  foreground,
}
